// extracted by mini-css-extract-plugin
export default {"headButtons":"SpecialTemplates_headButtons__7Qx+h","activityButton":"SpecialTemplates_activityButton__OJHry"};